import _toConsumableArray from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-635db194"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("通过 ");

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 驳回 ");

import authWrap from './components/authWrap.vue';
import AuthService from '@/api/auth';
import { useRoute } from 'vue-router';
import searchBanner from './components/searchBanner';
import commonTable from './components/commonTable';
import { myApproveHeader } from './commons/tableHeader';
import { ref, reactive, onMounted, watch, computed } from 'vue';
import { getApprovalHistoryDesc, doApprove, editAuthApprove } from './commons/authUtil';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var appKey = computed(function () {
      return route.params.project;
    });
    var tableHeader = ref(myApproveHeader);
    var searchParams = reactive({
      appKey: appKey.value || '',
      applyStatus: 'APPROVING',
      keyword: '',
      pageNo: 1,
      pageSize: 10
    });
    var tableOptions = reactive({
      loading: false,
      pagination: true,
      total: 0,
      selectedRow: null
    });
    var tableBody = reactive([]);

    var searchList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var _data$data;

        var data, result, tableBodyTemp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (params === undefined) searchParams.pageNo = 1;
                if (params !== null && params !== void 0 && params.pageNo) searchParams.pageNo = params.pageNo;
                if (params !== null && params !== void 0 && params.pageSize) searchParams.pageSize = params.pageSize;
                tableOptions.loading = true;
                _context.next = 6;
                return AuthService.getApproveList(_objectSpread(_objectSpread({}, searchParams), params));

              case 6:
                data = _context.sent;
                tableOptions.loading = false;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result;
                  tableOptions.total = result.totalCount;
                  tableBodyTemp = result.itemList || [];
                  tableBodyTemp.forEach(function (item) {
                    var otherObj = getApprovalHistoryDesc(item.approvalHistory, item.approvalStep); // 变更的权限类型为空，则取申请的权限类型

                    if (!otherObj.realAuthType) otherObj.realAuthType = item.actionDesc || item.roleName;
                    Object.assign(item, {
                      modifyName: item.actionDesc || item.roleName,
                      modifyId: item.action || item.roleId,
                      modifyList: []
                    }, otherObj);
                  });
                  tableBody.length = 0; // 清空原数组

                  tableBody.push.apply(tableBody, _toConsumableArray(tableBodyTemp)); // 解构然后push进去
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchList(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    watch(function () {
      return appKey.value;
    }, function (newKey, oldKey) {
      searchParams.appKey = newKey;
      searchList();
    });

    var editAuth = function editAuth(row) {
      editAuthApprove(row);
    };

    var approve = function approve(row, approvalResult) {
      tableOptions.loading = true;
      doApprove(row, approvalResult, searchList);
    };

    var onSearchHandler = function onSearchHandler(applyStatus, keyword) {
      searchParams.applyStatus = applyStatus;
      searchParams.keyword = keyword;
      searchList({
        pageNo: 1
      });
    };

    var handleSelectHandler = function handleSelectHandler(selection) {
      tableOptions.selectedRow = selection;
    };

    onMounted(function () {
      searchList();
    });
    return function (_ctx, _cache) {
      var _component_circle_check = _resolveComponent("circle-check");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_button = _resolveComponent("el-button");

      var _component_circle_close = _resolveComponent("circle-close");

      var _component_el_table_column = _resolveComponent("el-table-column");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(authWrap, {
        "search-params": _unref(searchParams)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(searchBanner), {
            "search-params": _unref(searchParams),
            placeholder: "请输入申请人或申请内容或ID进行搜索",
            onOnSearch: onSearchHandler
          }, null, 8, ["search-params"]), _createVNode(_unref(commonTable), {
            params: _unref(searchParams),
            options: _unref(tableOptions),
            "table-header": tableHeader.value,
            "table-body": _unref(tableBody),
            onHandleSelect: handleSelectHandler,
            onOnChangePage: searchList,
            onOnEdit: _cache[0] || (_cache[0] = function ($event) {
              return editAuth($event);
            })
          }, {
            default: _withCtx(function () {
              return [_unref(searchParams).applyStatus === 'APPROVING' ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "操作",
                width: "160"
              }, {
                default: _withCtx(function (scope) {
                  return [_createVNode(_component_el_button, {
                    class: "operate-btn",
                    type: "success",
                    size: "mini",
                    onClick: function onClick($event) {
                      return approve(scope.row, 'PASS');
                    },
                    style: {
                      "font-size": "12px"
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_icon, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_circle_check)];
                        }),
                        _: 1
                      }), _hoisted_1];
                    }),
                    _: 2
                  }, 1032, ["onClick"]), _createVNode(_component_el_button, {
                    class: "operate-btn",
                    type: "danger",
                    size: "mini",
                    onClick: function onClick($event) {
                      return approve(scope.row, 'REJECT');
                    },
                    style: {
                      "font-size": "12px"
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_icon, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_circle_close)];
                        }),
                        _: 1
                      }), _hoisted_2];
                    }),
                    _: 2
                  }, 1032, ["onClick"])];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["params", "options", "table-header", "table-body"])];
        }),
        _: 1
      }, 8, ["search-params"])]);
    };
  }
});